export default __webpack_public_path__ + "static/media/0xf153eff70dc0bf3b085134928daeea248d9b30d0.348d6a25.png";